import { api } from './client'

export interface ServerStatus {
  configured: boolean
  primary_sudo_set: boolean
  registration_enabled: boolean
  email_enabled: boolean
}

export interface AuthResult {
  token: string
  user_id: string
  username: string
}

export interface TokenInfo {
  id: string
  label: string
  client_type: string
  scopes: string[]
  created_at: string
  expires_at: string | null
  last_used_at: string | null
}

export interface TokenCreateResult extends TokenInfo {
  token: string
}

export async function getServerStatus(): Promise<ServerStatus> {
  return api.get<ServerStatus>('/auth/status')
}

export async function registerBegin(username: string, email: string): Promise<unknown> {
  return api.post('/auth/register/begin', { username, email })
}

export async function registerComplete(username: string, email: string, credential: unknown, deviceName?: string): Promise<AuthResult> {
  return api.post<AuthResult>('/auth/register/complete', { username, email, credential, device_name: deviceName })
}

export async function loginBegin(username: string): Promise<unknown> {
  return api.post('/auth/login/begin', { username })
}

export async function loginComplete(username: string, credential: unknown): Promise<AuthResult> {
  return api.post<AuthResult>('/auth/login/complete', { username, credential })
}

export async function listTokens(): Promise<TokenInfo[]> {
  return api.get<TokenInfo[]>('/auth/tokens')
}

export async function createToken(label: string, clientType = 'personal', scopes: string[] = []): Promise<TokenCreateResult> {
  return api.post<TokenCreateResult>('/auth/tokens', { label, client_type: clientType, scopes })
}

export async function revokeToken(tokenId: string): Promise<void> {
  return api.delete(`/auth/tokens/${tokenId}`)
}

export async function sendVerificationEmail(): Promise<void> {
  await api.post('/auth/verify-email/send')
}

export async function confirmEmailVerification(token: string): Promise<void> {
  await api.post('/auth/verify-email/confirm', { token })
}

export interface PasskeyInfo {
  id: string
  device_name: string | null
  created_at: string
  last_used_at: string | null
}

export async function listPasskeys(): Promise<PasskeyInfo[]> {
  return api.get<PasskeyInfo[]>('/auth/passkeys')
}

export async function deletePasskey(passkeyId: string): Promise<void> {
  return api.delete(`/auth/passkeys/${passkeyId}`)
}

export async function renamePasskey(passkeyId: string, deviceName: string): Promise<PasskeyInfo> {
  return api.patch<PasskeyInfo>(`/auth/passkeys/${passkeyId}`, { device_name: deviceName })
}

export async function sendPasskeyAddEmail(): Promise<void> {
  await api.post('/auth/passkey/add/send')
}

export async function passkeyAddBegin(token: string): Promise<unknown> {
  return api.post('/auth/passkey/add/begin', { token })
}

export async function passkeyAddComplete(token: string, credential: unknown, deviceName?: string): Promise<AuthResult> {
  return api.post<AuthResult>('/auth/passkey/add/complete', { token, credential, device_name: deviceName })
}
